import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthStateService } from './auth-state.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly authState = inject(AuthStateService);
  private readonly router = inject(Router);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Clone request and add Authorization header if token exists
    const token = this.authState.getToken();
    const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Log only errors that are not 401
        if (error.status && error.status !== 401) {
          Log.error(error);
        }
        if (error.status === 500 || error.status === 503) {
          const target = `/${error.status}`;
          if (this.router.url !== target) {
            void this.router.navigateByUrl(target);
          }
        }
        return throwError(() => error);
      }),
    );
  }
}
